import { VariantKey } from 'products/types'

/** 
This really should be a server-side fucntion that grabs prices from Fragile's API.

However, doing so would require a lot of work re-architecting the app to be able to access
server-side components that low down in the tree. (Or severe prop-drilling.)

Either way, this changes so infrequently that it's not worth the effort right now.

@author nick xitco
*/
export const FragilePilotPrices: Partial<Record<VariantKey, number>> = {
	full: 179,
	queen: 189,
	king: 209,
	caliking: 209,
}
